const accessTokenKey = 'ACCESS_TOKEN';
const refreshTokenKey = 'REFRESH_TOKEN';
const refreshRequestedKey = 'REFRESH_REQUESTED_TIME';
const idleKey = 'LAST_ACTIVE_TIME';
const signOutBroadCastKey = 'SIGNOUT_BROADCAST';

const setAccessToken = (accessToken) => {
  localStorage.setItem(accessTokenKey, accessToken);
};
const setRefreshToken = (refreshToken) => {
  localStorage.setItem(refreshTokenKey, refreshToken);
};
const setTokens = ({ accessToken, refreshToken }) => {
  setAccessToken(accessToken);
  setRefreshToken(refreshToken);
};

const getAccessToken = () => localStorage.getItem(accessTokenKey);

const getRefreshToken = () => localStorage.getItem(refreshTokenKey);

const removeAccessToken = () => {
  localStorage.removeItem(accessTokenKey);
};
const removeRefreshToken = () => {
  localStorage.removeItem(refreshTokenKey);
};
const clearTokens = () => {
  removeAccessToken();
  removeRefreshToken();
};
const getLastRecordedActiveTimeData = () => localStorage.getItem(idleKey);
const setLastRecordedActiveTimeData = (data) => localStorage.setItem(idleKey, data);

const getRefreshReqData = () => localStorage.getItem(refreshRequestedKey);
const setRefreshReqData = (data) => localStorage.setItem(refreshRequestedKey, data);

// retreiving is not needed as this is only one way
const setSignOutBroadcastData = (data) => localStorage.setItem(signOutBroadCastKey, data);

export function parseJwt(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`).join(''));

  return JSON.parse(jsonPayload);
}

// eslint-disable-next-line import/prefer-default-export
export const tokenStorage = {
  setTokens,
  setAccessToken,
  setRefreshToken,
  getAccessToken,
  getRefreshToken,
  clearTokens,
  removeAccessToken,
  removeRefreshToken,
  getLastRecordedActiveTimeData,
  setLastRecordedActiveTimeData,
  getRefreshReqData,
  setRefreshReqData,
  setSignOutBroadcastData,
};
